export const collapseContextKey = Symbol('collapseContextKey');
export const UPDATE_MODEL_EVENT = 'update:modelValue';
export const CHANGE_EVENT = 'change';
export const INPUT_EVENT = 'input';
export const STATE_CHANGED_EVENT = 'state-changed';
/**
 * This value follows the WAI-ARIA Authoring Practices Guide for accordion patterns,
 * which recommends limiting the number of panels with region role to avoid
 * overwhelming screen reader users with too many landmark regions.
 *
 * @see https://www.w3.org/WAI/ARIA/apg/patterns/accordion/#wai-ariaroles,states,andproperties
 */
export const MAX_PANELS_FOR_REGION_ROLE = 7;
